import { UserDataProp } from './types';
import * as THREE from 'three';

export abstract class RenderUtils {
	static clearGroup(group: THREE.Group) {
		group.traverse((object) => {
			if (!RenderUtils.isMesh(object)) return;

			if (object.geometry) object.geometry.dispose();
		});

		group.clear();
	}

	static isMesh(object: THREE.Object3D): object is THREE.Mesh {
		return object instanceof THREE.Mesh;
	}

	static searchSofaModuleGroup(object: THREE.Object3D): THREE.Object3D | null {
		if (object.userData[UserDataProp.IS_SOFA_MODULE]) return object;
		if (!object.parent || object.parent.userData[UserDataProp.IS_COLLECTION])
			return null;
		return RenderUtils.searchSofaModuleGroup(object.parent);
	}
}
